import * as React from 'react';
import { useField } from 'react-final-form';
import { useTranslator } from '@gandi/translate';
import { Base, IconButton, Svg, Text } from '@gandi/ui';
import ForwardCell from './ForwardCell';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "item": "WebForwardList-item_1It0-",
  "itemSource": "WebForwardList-itemSource_2VmYo",
  "itemArrow": "WebForwardList-itemArrow_iAPDi",
  "itemTarget": "WebForwardList-itemTarget_235ll",
  "itemType": "WebForwardList-itemType_2e5RY",
  "itemAction": "WebForwardList-itemAction_3Aid8",
  "svgArrow": "WebForwardList-svgArrow__X7S5"
};
function RawTextField({
  name
}) {
  const {
    input: {
      value
    },
    meta: {
      error
    }
    // $FlowFixMe[prop-missing]
  } = useField(name, {
    subscription: {
      value: true,
      error: true
    }
  });
  // Display errors from validator in case a forward has been saved with an error
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      children: value
    }), error && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
        color: "red",
        children: error
      })]
    })]
  });
}
const renderSourceProtocol = webForward => {
  switch (webForward.sourceProtocol) {
    case 'httpsonly':
      return 'https';
    default:
      return webForward.sourceProtocol;
  }
};
const ForwardType = ({
  forward
}) => {
  const {
    __
  } = useTranslator();
  switch (forward.type) {
    case 'cloak':
      return __('Masked');
    case 'http301':
      return __('Permanent');
    case 'http302':
      return __('Temporary');
    default:
      return forward.type;
  }
};
const WebForwardList = ({
  forwardFields,
  readOnly,
  onDeleteItem
}) => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexCol: true,
    gap: "xxsmall",
    children: forwardFields.map(forwardField => /*#__PURE__*/_jsxs(Base, {
      className: styles.item,
      children: [/*#__PURE__*/_jsx(ForwardCell, {
        className: styles.itemSource,
        overflow: "break",
        children: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: `${renderSourceProtocol(forwardField.forward)}://${forwardField.forward.host || ''}`
        })
      }), /*#__PURE__*/_jsx(ForwardCell, {
        className: styles.itemArrow,
        children: /*#__PURE__*/_jsx(Svg, {
          name: "arrowRight",
          className: styles.svgArrow
        })
      }), /*#__PURE__*/_jsx(ForwardCell, {
        className: styles.itemTarget,
        overflow: "break",
        children: /*#__PURE__*/_jsx(RawTextField, {
          name: `${forwardField.prefix}.targetUrl`
        })
      }), /*#__PURE__*/_jsx(ForwardCell, {
        className: styles.itemType,
        children: /*#__PURE__*/_jsx(Text, {
          transform: "uppercase",
          children: /*#__PURE__*/_jsx(ForwardType, {
            forward: forwardField.forward
          })
        })
      }), !readOnly && /*#__PURE__*/_jsx(ForwardCell, {
        flexAuto: false,
        className: styles.itemAction,
        children: /*#__PURE__*/_jsx(IconButton, {
          type: "button",
          icon: "trash",
          shape: "circle",
          intent: "danger",
          kind: "outline",
          small: true,
          onClick: () => onDeleteItem(forwardField),
          children: __('Delete')
        })
      })]
    }, forwardField.prefix))
  });
};
export default WebForwardList;